export const ALGOLIA_CONFIG = {
  appId: '56E22C18OP',
  searchApiKey: 'fa52c3174cd8150c892620659923b4b1',
  insights: {
    enabled: true,
    useCookie: true
  }
};

export const ALGOLIA_INDICES = {
  BUSINESSES: 'businesses',
  BUSINESSES_QUERY_SUGGESTIONS: 'businesses_query_suggestions'
} as const;

export const ALGOLIA_SEARCH_PARAMS = {
  hitsPerPage: 20,
  attributesToRetrieve: ['*'],
  clickAnalytics: true,
  enablePersonalization: true,
  getRankingInfo: true
} as const;

